<div
  class="analytics-dashboard-container"
  [class.analytics-dashboard-container--panel]="defaultSubscriptionId !== undefined"
  [class.analytics-dashboard-container--hidden]="
    defaultSubscriptionId !== undefined && show !== undefined && !show()
  "
>
  <div class="analytics-dashboard b4a-tv-dashboard">
    <app-dashboard-header
      [title]="
        defaultSubscriptionId !== undefined
          ? 'Previsão de Assinaturas - ' + (subscription?.label || '')
          : 'Previsão de Assinaturas - Todas'
      "
    ></app-dashboard-header>

    <main class="b4a-main-container">
      <div class="analytics-dashboard-layout">
        <div class="analytics-filters" *ngIf="defaultSubscriptionId === undefined">
          <form class="analytics-filters__form form-b4a">
            <span class="p-float-label">
              <p-dropdown
                inputId="subscriptionId"
                [options]="subscriptions"
                (onChange)="changeSubscription()"
                [formControl]="subscriptionId"
                appendTo="body"
                [autoDisplayFirst]="false"
              >
              </p-dropdown>
              <label for="subscriptionId">Assinatura</label>
            </span>
          </form>
        </div>

        <section class="analytics-content" *ngIf="subscribers?.length && subscribersRealtime">
          <div class="analytics-cards-grid">
            <app-dashboard-card
              class="analytics-card"
              [class.analytics-card--success]="
                subscribersRealtimeTotal()?.total >= totalSubscriptionsTillTime
              "
              [class.analytics-card--danger]="
                subscribersRealtimeTotal()?.total < totalSubscriptionsTillTime
              "
            >
              <span class="analytics-card__title">Acumulado do Dia</span>
              <span class="analytics-card__value">
                {{ subscribersRealtimeTotal()?.total | number: '1.0-0' }}
              </span>
              <span class="analytics-card__hint">assinaturas</span>
            </app-dashboard-card>

            <app-dashboard-card class="analytics-card">
              <span class="analytics-card__title">Acumulado Médio | (Últimos 7d)</span>
              <span class="analytics-card__value">
                {{ totalSubscriptionsTillTime | number: '1.2-2' }}
              </span>
              <span class="analytics-card__hint">assinaturas</span>
            </app-dashboard-card>

            <app-dashboard-card
              class="analytics-card"
              [class.analytics-card--success]="subscriptionsForecast >= avgSubscriptions"
              [class.analytics-card--danger]="subscriptionsForecast < avgSubscriptions"
            >
              <span class="analytics-card__title">Previsão do Dia</span>
              <span class="analytics-card__value">
                {{ subscriptionsForecast | number: '1.0-0' }}
              </span>
              <span class="analytics-card__hint">assinaturas</span>
            </app-dashboard-card>

            <app-dashboard-card class="analytics-card">
              <span class="analytics-card__title">Média Diária | (Últimos 7d)</span>
              <span class="analytics-card__value">
                {{ avgSubscriptions | number: '1.2-2' }}
              </span>
              <span class="analytics-card__hint">assinaturas</span>
            </app-dashboard-card>
          </div>

          <app-dashboard-card class="analytics-chart-card analytics-chart-card--compact">
            <div dashboard-card-content>
              <p-chart
                type="bar"
                [data]="chartData"
                [options]="chartConfig"
                id="chart"
                [responsive]="false"
                [width]="width"
                [height]="chartHeight"
                #chart
                *ngIf="chartData && width"
              ></p-chart>
            </div>
          </app-dashboard-card>
        </section>

        <div class="analytics-empty" *ngIf="!subscribers?.length || !subscribersRealtime">
          Nenhum dado disponível para a assinatura selecionada.
        </div>
      </div>
    </main>
  </div>
</div>
